import { EMPTY } from "@lib/helper/stringUtils";
import { symbolImages } from "@lib/images";

export enum eSymbol {
  yes = "S-Yes",
  no = "S-No",
  doNotKnow = "S-Dnk",
  yesButNotAll = "S-Part",
}

const PERCENTAGE_THRESHOLD = 60;

export const colorSymbolWithPercentage = (percentage: number): string => {
  if (percentage === 100) return symbolImages.yes;
  if (percentage === 0) return symbolImages.no;
  return percentage >= PERCENTAGE_THRESHOLD ? symbolImages.yesButNotAllOver60 : symbolImages.yesButNotAll;
};

export const textSymbolWithPercentage = (percentage: number): string => {
  if (percentage === 100) return symbolMapToText[eSymbol.yes];
  if (percentage === 0) return symbolMapToText[eSymbol.no];
  return symbolMapToText[eSymbol.yesButNotAll];
};

const symbolMap: { [name: string]: string } = {
  [eSymbol.yes]: symbolImages.yes,
  [eSymbol.no]: symbolImages.no,
  [eSymbol.doNotKnow]: symbolImages.doNotKnow,
  [eSymbol.yesButNotAll]: symbolImages.yesButNotAll,
};

const symbolMapToText: { [name: string]: string } = {
  [eSymbol.yes]: "symbol.yes",
  [eSymbol.no]: "symbol.no",
  [eSymbol.doNotKnow]: "symbol.doNotKnow",
  [eSymbol.yesButNotAll]: "symbol.yesButNotAll",
};

export const selectImgSymbols = (symbolCode: eSymbol, percentage?: number): string => {
  return typeof percentage === "number" ? colorSymbolWithPercentage(percentage) : symbolMap[symbolCode];
};

export const selectTextSymbols = (symbolCode: eSymbol, percentage?: number): string => {
  return typeof percentage === "number" ? textSymbolWithPercentage(percentage) : symbolMapToText[symbolCode];
};

export function addPercentageToText(
  unknownPercentage: string,
  text?: string,
  percentage?: number,
  symbol?: eSymbol
): string {
  if (!text) return EMPTY;
  if (!text.includes("%%")) return text;

  let stringPercentage = (percentage ? Math.floor(percentage) : 0).toString() + "%";
  if (symbol === eSymbol.doNotKnow) {
    stringPercentage = unknownPercentage;
  }
  return text.replace("%%", stringPercentage);
}
